module.exports = __webpack_public_path__ + "img/Durazno-temporada.6bcdd88f.jpg";